import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';
import { OblateDataResponse } from '../interfaces/oblate.interface';

@Injectable({
  providedIn: 'root',
})
export class OblateDetailsService extends ApiService {

  public fetchOblateData(reqData: any): Observable<any> {
    return this.post<OblateDataResponse>(ROUTES.OBLATE_DATA, {
      body: reqData,
    });
  }

  public fetchNoOfWorkingDays(reqData: any): Observable<any> {
    return this.get<any>(ROUTES.OBLATE_NO_OF_WORKING,
      //   {
      //   params: reqData,
      // }
    );
  }

  public fetchOblateCount(reqData: any): Observable<any> {
    return this.post<any>(ROUTES.OBLATE_COUNT, {
      body: reqData,
    });
  }

  public addOblate(reqData: any): Observable<any> {
    return this.post<any>(ROUTES.ADD_NEW_OBLATE, {
      body: reqData,
    });
  }

  public addOblateOnline(reqData: any): Observable<any> {
    return this.post<any>(ROUTES.ADD_NEW_OBLATE_ONLINE, {
      body: reqData,
    });
  }

  public addOblateOffline(reqData: any): Observable<any> {
    return this.post<any>(ROUTES.ADD_NEW_OBLATE_OFFLINE, {
      body: reqData,
    });
  }

  public uploadDpPhoto(reqData: any): Observable<any> {
    return this.post<any>(ROUTES.OBLATE_UPLOAD_DP_IMAGE, {
      body: reqData,
    });
  }

  public oblateReport(reqData: any): Observable<any> {
    let params = {
      slNumber: reqData.slNumber,
      ritwikName: reqData.ritwikName,
      ritwikCode: reqData.ritwikCode,
      firstName: reqData.firstName,
      lastName: reqData.lastName,
      startDate: reqData.startDate,
      endDate: reqData.endDate,
      addedUser: reqData.addedUser
    }
    return this.get<any>(ROUTES.OBLATE_REPORT, { params })
  }

  public addLotInfo(reqData: any): Observable<any> {
    return this.post<any>(ROUTES.OBLATE_ADD_LOTINFO, {
      body: reqData,
    })
  }

  public fetchLotCount(reqData: any): Observable<any> {
    let params = {
      lotno: reqData.lotnumber
    }
    return this.get<any>(ROUTES.OBLATE_FETCH_LOTCOUNT, { params })
  }

  public fetchOfflineDraftOblateList(): Observable<any> {
    return this.get<any>(ROUTES.OBLATE_OFFLINE_DRAFT_LIST)
  }

  public fetchOfflineDraftDataBySlNo(slno: number): Observable<any> {
    return this.get<any>(
      this.replacePathInfo(ROUTES.OBLATE_OFFLINE_DRAFT_LIST_BY_ID, {
        memkey: slno,
      })
    )
  }

  public deleteOblateData(slno: number): Observable<any> {
    return this.delete<any>(
      this.replacePathInfo(ROUTES.OBLATE_OFFLINE_DRAFT_LIST_BY_ID, {
        memkey: slno,
      })
    )
  }

  public editOblateDetails(memKey: any, bodyObj: any): Observable<any> {
    return this.put<any>(
      this.replacePathInfo(ROUTES.OBLATE_UPDATE_OFFLINE_DATA_BY_ID, {
        memkey: memKey
      }),
      {
        body: bodyObj,
      }
    );
  }

  public getOblateCounts(): Observable<any> {
    return this.get<any>(ROUTES.OBLATE_COUNT_REPORT);
  }

  public getOblateLists(pgno: number, pgSize: number, type?: string): Observable<any> {
    let params = {
      ...(type && { type }),
      pageNo: pgno,
      pageSize: pgSize
    }
    return this.get<any>(ROUTES.OBLATE_LISTS, { params });
  }

  public getOblateDailyCount(): Observable<any> {
    return this.get<any>(ROUTES.OBLATE_DAILY_COUNT)
  }

  getdPEntryStats(qParams: any): Observable<any> {
    const params = qParams
    return this.get<any>(ROUTES.DP_ENTRY_STATS, { params })
  }
}
